import React, { ReactNode, useRef } from 'react';

import { Elements } from '@stripe/react-stripe-js';
import { StripeElementsOptions, loadStripe } from '@stripe/stripe-js';

import { useThemeContext } from '@infoods/lifebase-ui';
import { getStripeElementsAppearance } from './StripeElementsProvider.settings';

type StripeElementsProviderProps = {
  publishableKey: string;
  connectedAccountId?: string | null;
  children: ReactNode;
  elementsOptions?: StripeElementsOptions;
};

const StripeElementsProvider = ({
  publishableKey,
  connectedAccountId,
  elementsOptions,
  children,
}: StripeElementsProviderProps) => {
  const { palette } = useThemeContext();

  // prevent re-call on every render
  const stripePromiseRef = useRef(
    loadStripe(publishableKey, {
      stripeAccount: connectedAccountId || undefined,
    }),
  );

  return (
    <Elements
      stripe={stripePromiseRef.current}
      options={{
        appearance: getStripeElementsAppearance(palette),
        ...elementsOptions,
      }}
    >
      {children}
    </Elements>
  );
};

export { StripeElementsProvider, StripeElementsProviderProps };
